import { render } from "./AttachmentPanel.vue?vue&type=template&id=0ea57320"
import script from "./AttachmentPanel.vue?vue&type=script&lang=ts"
export * from "./AttachmentPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script